import { Form } from 'react-bootstrap';

import type { FiscalPeriodConfig, FiscalYearPreview } from 'utils/fiscalPeriods';

import { ConfigJsonPreview } from './ConfigJsonPreview';
import { FiscalYearTable } from './FiscalYearTable';
import { PeriodDetailTable } from './PeriodDetailTable';
import { PeriodStrip } from './PeriodStrip';

interface Props {
  readonly config: FiscalPeriodConfig;
  readonly years: readonly FiscalYearPreview[];
  readonly selectedYear: FiscalYearPreview;
  readonly patternLabel: string;
  readonly onPreviewYearChange: (year: number) => void;
}

/** Multi-year fiscal preview: year table, strip, period detail, and JSON. */
export const FiscalPreviewSection = ({ config, years, selectedYear, patternLabel, onPreviewYearChange }: Props) => (
  <>
    <div className="d-flex align-items-center justify-content-between mb-2">
      <h6 className="mb-0">Preview</h6>
      <Form.Group className="mb-0 d-flex align-items-center gap-2" controlId="fiscal-preview-year">
        <Form.Label className="mb-0 small text-muted">Detail for</Form.Label>
        <Form.Select size="sm" value={selectedYear.year} onChange={(e) => onPreviewYearChange(Number(e.target.value))} style={{ width: 'auto' }}>
          {years.map((y) => (
            <option key={y.year} value={y.year}>
              FY {y.year}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>
    <p className="text-muted small">
      The year column is the calendar year of the anchor date (January 2026 → FY 2026), not an accounting label. NRF FY 2024 therefore starts in January 2023
      because it is defined by its year-end.
    </p>

    <FiscalYearTable years={years} selectedYear={selectedYear.year} />
    <PeriodStrip year={selectedYear} patternLabel={patternLabel} />
    <PeriodDetailTable periods={selectedYear.periods} />
    <ConfigJsonPreview config={config} />
  </>
);
